import React from 'react';

const ApplicationModal = ({ application, onClose }) => {
  const renderMemberDetails = () => (
    <div className="application-details">
      <h4>Application Type</h4>
      <div className="detail-row">
        <span className="detail-label">Application Type:</span>
        <span className="detail-value">{application.applicationType === 'new' ? 'NEW MEMBERSHIP APPLICATION FORM' : 'RENEWAL'}</span>
      </div>
      
      <h4>Membership Plan</h4>
      <div className="detail-row">
        <span className="detail-label">Membership Plan:</span>
        <span className="detail-value">{application.membershipPlan || 'N/A'}</span>
      </div>
      
      <h4>Section 1: Personal Details</h4>
      <div className="detail-row">
        <span className="detail-label">Full Names:</span>
        <span className="detail-value">{application.fullNames || application.fullName || application.name || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Other Names:</span>
        <span className="detail-value">{application.otherNames || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Date of Birth:</span>
        <span className="detail-value">{application.dateOfBirth || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">ID Number:</span>
        <span className="detail-value">{application.identityDocumentNumber || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Gender:</span>
        <span className="detail-value">{application.gender || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Nationality:</span>
        <span className="detail-value">{application.nationality || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Marital Status:</span>
        <span className="detail-value">{application.currentMaritalStatus || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Spouse Name:</span>
        <span className="detail-value">{application.fullNamesSpouse || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Previous Marital Status:</span>
        <span className="detail-value">{application.previousMaritalStatus?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Previous Spouse Name:</span>
        <span className="detail-value">{application.fullNamesPreviousSpouse || 'N/A'}</span>
      </div>
      
      <h4>Section 2: Contacts & Residence</h4>
      <div className="detail-row">
        <span className="detail-label">Main Contact:</span>
        <span className="detail-value">{application.contactNumbersCallsMain || application.contactNumber || application.phone || application.contact || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Other Contact:</span>
        <span className="detail-value">{application.contactNumbersCallsOther || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">WhatsApp Main:</span>
        <span className="detail-value">{application.contactNumbersWhatsappMain || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">WhatsApp Other:</span>
        <span className="detail-value">{application.contactNumbersWhatsappOther || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Email:</span>
        <span className="detail-value">{application.personalEmailAddress || application.email || application.emailAddress || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Home Location:</span>
        <span className="detail-value">{application.homeLocationVillage || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Street Address:</span>
        <span className="detail-value">{application.streetFullDescription || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Homeowner/Chief:</span>
        <span className="detail-value">{application.nameHomeownerChief || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Social Media:</span>
        <span className="detail-value">{application.socialMediaChannelNames || 'N/A'}</span>
      </div>
      
      <h4>Section 3: Next of Kin Details</h4>
      <div className="detail-row">
        <span className="detail-label">Full Names:</span>
        <span className="detail-value">{application.nextKinTitleFullNames || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Relationship:</span>
        <span className="detail-value">{application.nextKinRelationship || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Home Location:</span>
        <span className="detail-value">{application.nextKinHomeLocationVillage || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Contact Calls:</span>
        <span className="detail-value">{application.nextKinContactCalls || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Contact Text:</span>
        <span className="detail-value">{application.nextKinContactText || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Email:</span>
        <span className="detail-value">{application.nextKinEmailAddress || 'N/A'}</span>
      </div>
      
      <h4>Section 4: Career & Employment</h4>
      <h5>Current Employment</h5>
      <div className="detail-row">
        <span className="detail-label">Employer Name:</span>
        <span className="detail-value">{application.currentEmployerName || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Employment Period:</span>
        <span className="detail-value">{application.currentStartDateEndDate || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Department:</span>
        <span className="detail-value">{application.currentDepartment || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Position:</span>
        <span className="detail-value">{application.currentPosition || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Employment Number:</span>
        <span className="detail-value">{application.currentEmploymentNumber || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Contact:</span>
        <span className="detail-value">{application.currentContactMain || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Location:</span>
        <span className="detail-value">{application.currentPlaceLocation || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Industry:</span>
        <span className="detail-value">{application.currentIndustrySector || 'N/A'}</span>
      </div>
      
      <h5>Previous Employment</h5>
      <div className="detail-row">
        <span className="detail-label">Employer Name:</span>
        <span className="detail-value">{application.immediatePastEmployerName || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Employment Period:</span>
        <span className="detail-value">{application.immediatePastStartDateEndDate || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Department:</span>
        <span className="detail-value">{application.immediatePastDepartment || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Position:</span>
        <span className="detail-value">{application.immediatePastPosition || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Employment Number:</span>
        <span className="detail-value">{application.immediatePastEmploymentNumber || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Contact:</span>
        <span className="detail-value">{application.immediatePastContactMain || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Location:</span>
        <span className="detail-value">{application.immediatePastPlaceLocation || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Industry:</span>
        <span className="detail-value">{application.immediatePastIndustrySector || 'N/A'}</span>
      </div>
      
      <div className="detail-row">
        <span className="detail-label">Highest Qualification:</span>
        <span className="detail-value">{application.highestQualification || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Career Priorities:</span>
        <span className="detail-value">{application.careerPriorities?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">FMLC Impact Desired:</span>
        <span className="detail-value">{application.fmlcImpact?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Other Impact:</span>
        <span className="detail-value">{application.specifyOtherImpact || 'N/A'}</span>
      </div>
      
      <h4>Section 5: Work, Life Schedules & Activities Style</h4>
      <div className="detail-row">
        <span className="detail-label">Preferred Engagement Times:</span>
        <span className="detail-value">{application.preferredEngagementTimes?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Best Activity Times:</span>
        <span className="detail-value">{application.bestActivityTimes?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Preferred Activity Setup:</span>
        <span className="detail-value">{application.preferredActivitySetup?.join(', ') || 'N/A'}</span>
      </div>
      
      <h4>Section 6: Engagement with FMLC Brand</h4>
      <div className="detail-row">
        <span className="detail-label">Motivating Incentives:</span>
        <span className="detail-value">{application.motivatingInceptives?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">FMLC Activities:</span>
        <span className="detail-value">{application.fmlcOrientedActivities?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Refer Others:</span>
        <span className="detail-value">{application.referOthers || 'N/A'}</span>
      </div>
      
      <h4>Section 7: Funeral Cover & Benefits</h4>
      <h5>Children Details</h5>
      {application.children && application.children.map((child, index) => (
        child && child.name && (
          <div key={index} className="detail-group">
            <div className="detail-row">
              <span className="detail-label">Child {index + 1} Name:</span>
              <span className="detail-value">{child.name || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Gender:</span>
              <span className="detail-value">{child.gender || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Date of Birth:</span>
              <span className="detail-value">{child.dob || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Issue Card:</span>
              <span className="detail-value">{child.issueCard || 'N/A'}</span>
            </div>
          </div>
        )
      ))}
      
      <div className="detail-row">
        <span className="detail-label">Children Personalities:</span>
        <span className="detail-value">{application.childrenPersonalities?.join(', ') || 'N/A'}</span>
      </div>
      
      <div className="detail-row">
        <span className="detail-label">Add Parents/In-Laws:</span>
        <span className="detail-value">{application.addParentsInLawsExtended?.join(', ') || 'N/A'}</span>
      </div>
      
      <h5>Parents & In-Laws</h5>
      {application.parentsInLaws && application.parentsInLaws.map((parent, index) => (
        parent && parent.name && (
          <div key={index} className="detail-group">
            <div className="detail-row">
              <span className="detail-label">Parent/In-Law {index + 1} Name:</span>
              <span className="detail-value">{parent.name || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Gender:</span>
              <span className="detail-value">{parent.gender || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Date of Birth:</span>
              <span className="detail-value">{parent.dob || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Cover Type:</span>
              <span className="detail-value">{parent.coverType || 'N/A'}</span>
            </div>
          </div>
        )
      ))}
      
      <div className="detail-row">
        <span className="detail-label">Parents Interests:</span>
        <span className="detail-value">{application.parentsInterests?.join(', ') || 'N/A'}</span>
      </div>
      
      <h5>Extended Family</h5>
      {application.extendedFamily && application.extendedFamily.map((relative, index) => (
        relative && relative.name && (
          <div key={index} className="detail-group">
            <div className="detail-row">
              <span className="detail-label">Relative {index + 1} Name:</span>
              <span className="detail-value">{relative.name || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Gender:</span>
              <span className="detail-value">{relative.gender || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Date of Birth:</span>
              <span className="detail-value">{relative.dob || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Cover Type:</span>
              <span className="detail-value">{relative.coverType || 'N/A'}</span>
            </div>
          </div>
        )
      ))}
      
      <div className="detail-row">
        <span className="detail-label">External Family Motivations:</span>
        <span className="detail-value">{application.externalFamilyMotivations?.join(', ') || 'N/A'}</span>
      </div>
      
      <h4>Section 8: Beneficiary Details</h4>
      <div className="detail-row">
        <span className="detail-label">Beneficiary Name:</span>
        <span className="detail-value">{application.beneficiaryTitleFullNames || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">ID Number:</span>
        <span className="detail-value">{application.beneficiaryIdNumber || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Nationality:</span>
        <span className="detail-value">{application.beneficiaryNationality || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Relationship:</span>
        <span className="detail-value">{application.beneficiaryRelationship || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Home Location:</span>
        <span className="detail-value">{application.beneficiaryHomeLocationVillage || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Contact Calls:</span>
        <span className="detail-value">{application.beneficiaryContactCalls || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Contact Text:</span>
        <span className="detail-value">{application.beneficiaryContactText || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Email:</span>
        <span className="detail-value">{application.beneficiaryEmailAddress || 'N/A'}</span>
      </div>
      
      <h4>Membership Fee & Payment Details</h4>
      <div className="detail-row">
        <span className="detail-label">Main Subscription Qty:</span>
        <span className="detail-value">{application.mainSubscriptionFeeQty || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Membership Card Qty:</span>
        <span className="detail-value">{application.membershipCardQty || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Additional Membership Qty:</span>
        <span className="detail-value">{application.additionalMembershipQty || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Subscription Frequency:</span>
        <span className="detail-value">{application.subscriptionFrequency || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Agree to Pay:</span>
        <span className="detail-value">{application.agreeToPay ? 'Yes' : 'No'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Payment Method:</span>
        <span className="detail-value">{application.paymentMethod || 'N/A'}</span>
      </div>
      {application.paymentMethod === 'mobile' && (
        <>
          <div className="detail-row">
            <span className="detail-label">M-Pesa Number:</span>
            <span className="detail-value">{application.mpesaNumber || application.mPesaNumber || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">EcoCash Number:</span>
            <span className="detail-value">{application.ecocashNumber || application.ecoCashNumber || 'N/A'}</span>
          </div>
        </>
      )}
      {application.paymentMethod === 'bank' && (
        <>
          <div className="detail-row">
            <span className="detail-label">Account Holder:</span>
            <span className="detail-value">{application.accountHolder || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Bank Name:</span>
            <span className="detail-value">{application.bankName || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Account Number:</span>
            <span className="detail-value">{application.accountNo || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Branch Code:</span>
            <span className="detail-value">{application.branchCode || 'N/A'}</span>
          </div>
        </>
      )}
      
      <h4>Declaration</h4>
      <div className="detail-row">
        <span className="detail-label">Agree to Terms:</span>
        <span className="detail-value">{application.agreeToTerms ? 'Yes' : 'No'}</span>
      </div>
      
      <h4>Query</h4>
      <div className="detail-row">
        <span className="detail-label">Coordinator Query:</span>
        <span className="detail-value">{application.coordinatorQuery || 'N/A'}</span>
      </div>
      
      <h4>Attachments</h4>
      <div className="detail-row">
        <span className="detail-label">Personal ID:</span>
        <span className="detail-value">{application.personalIdChecked ? 'Provided' : 'Not Provided'}</span>
      </div>
      
      <h4>Approval Details</h4>
      <div className="detail-row">
        <span className="detail-label">Approver Name:</span>
        <span className="detail-value">{application.approverTitleFullNames || application.approverName || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Approver Position:</span>
        <span className="detail-value">{application.approverPosition || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Approval Date:</span>
        <span className="detail-value">
          {application.approverDate || application.approvedAt || application.approvalDate || application.approvalTimestamp
            ? new Date((application.approverDate || application.approvedAt || application.approvalDate || application.approvalTimestamp).seconds * 1000).toLocaleDateString()
            : 'N/A'}
        </span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Approver Signature:</span>
        <span className="detail-value">{application.approverSignature || 'N/A'}</span>
      </div>
      
      <h4>Submission Metadata</h4>
      <div className="detail-row">
        <span className="detail-label">Submitted By:</span>
        <span className="detail-value">{application.submittedBy || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Last Updated:</span>
        <span className="detail-value">
          {application.lastUpdated
            ? new Date(application.lastUpdated.seconds * 1000).toLocaleDateString()
            : 'N/A'}
        </span>
      </div>
      
      <h4>Status History</h4>
      {application.statusHistory && application.statusHistory.length > 0 ? (
        application.statusHistory.map((status, index) => (
          <div key={index} className="detail-group">
            <div className="detail-row">
              <span className="detail-label">Status {index + 1}:</span>
              <span className="detail-value">{status.status || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Date:</span>
              <span className="detail-value">
                {status.date
                  ? new Date(status.date.seconds * 1000).toLocaleDateString()
                  : 'N/A'}
              </span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Updated By:</span>
              <span className="detail-value">{status.updatedBy || 'N/A'}</span>
            </div>
          </div>
        ))
      ) : (
        <div className="detail-row">
          <span className="detail-label">Status History:</span>
          <span className="detail-value">No history available</span>
        </div>
      )}
    </div>
  );

  const renderPartnerDetails = () => (
    <div className="application-details">
      <h4>Application Type</h4>
      <div className="detail-row">
        <span className="detail-label">New Application:</span>
        <span className="detail-value">{application.newApplication ? 'Yes' : 'No'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Renewal Application:</span>
        <span className="detail-value">{application.renewalApplication ? 'Yes' : 'No'}</span>
      </div>
      
      <h4>Section 1: Entity Information</h4>
      <div className="detail-row">
        <span className="detail-label">Entity Registered Name:</span>
        <span className="detail-value">{application.entityRegisteredName || application.businessName || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Trading Name:</span>
        <span className="detail-value">{application.tradingName || application.businessName || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Business Registration Number:</span>
        <span className="detail-value">{application.businessRegistrationNumber || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Tax Identification Number:</span>
        <span className="detail-value">{application.taxIdentificationNumber || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Director Names:</span>
        <span className="detail-value">{application.directorNames || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Industry/Sector:</span>
        <span className="detail-value">{application.industrySector || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Office Contact Number:</span>
        <span className="detail-value">{application.officeContactNumber || application.contactNumber || application.phone || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Business Email:</span>
        <span className="detail-value">{application.businessEmail || application.email || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Physical Business Location:</span>
        <span className="detail-value">{application.physicalBusinessLocation || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Street Address:</span>
        <span className="detail-value">{application.streetAddress || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">District:</span>
        <span className="detail-value">{application.district || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Number of Employees:</span>
        <span className="detail-value">{application.numberOfEmployees || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Website:</span>
        <span className="detail-value">{application.website || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Social Media Links:</span>
        <span className="detail-value">{application.socialMediaLinks || 'N/A'}</span>
      </div>
      
      <h4>Section 2: Business Liaison Contact</h4>
      <div className="detail-row">
        <span className="detail-label">Liaison Title & Full Names:</span>
        <span className="detail-value">{application.liaisonTitleFullNames || application.contactPerson || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Liaison Job Position:</span>
        <span className="detail-value">{application.liaisonJobPosition || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Liaison Department:</span>
        <span className="detail-value">{application.liaisonDepartment || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Liaison Contact Number:</span>
        <span className="detail-value">{application.liaisonContactNumber || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Liaison Direct Email:</span>
        <span className="detail-value">{application.liaisonDirectEmail || 'N/A'}</span>
      </div>
      
      <h4>Section 3: Business Line of Operation Survey</h4>
      <div className="detail-row">
        <span className="detail-label">Business Lines:</span>
        <span className="detail-value">
          {[
            application.groceriesHouseholdEssentials ? 'Groceries & Household Essentials' : null,
            application.healthcareWellness ? 'Healthcare & Wellness' : null,
            application.clothingPersonalCare ? 'Clothing & Personal Care' : null,
            application.businessDevelopmentEntrepreneurship ? 'Business Development & Entrepreneurship' : null,
            application.entertainmentLiveEvents ? 'Entertainment & Live Events' : null,
            application.housingUtilities ? 'Housing & Utilities' : null,
            application.sportsRecreation ? 'Sports & Recreation' : null,
            application.educationSkillsDevelopment ? 'Education & Skills Development' : null,
            application.tourismArtsCulture ? 'Tourism, Arts & Culture' : null,
            application.technologyConnectivity ? 'Technology & Connectivity' : null,
            application.travelMobility ? 'Travel & Mobility' : null,
            application.lodgingAccommodation ? 'Lodging and Accommodation' : null,
            application.industryFacilityTours ? 'Industry and Facility Tours' : null,
            application.othersOperation ? 'Others' : null
          ].filter(Boolean).join(', ') || 'N/A'}
        </span>
      </div>
      
      <h4>Section 4: Business Engagement Areas</h4>
      <div className="detail-row">
        <span className="detail-label">Engagement Areas:</span>
        <span className="detail-value">
          {[
            application.generalManagement ? 'General Management' : null,
            application.operations ? 'Operations' : null,
            application.finance ? 'Finance' : null,
            application.purchasing ? 'Purchasing' : null,
            application.marketing ? 'Marketing' : null,
            application.informationTechnology ? 'Information Technology' : null,
            application.humanResources ? 'Human Resources' : null,
            application.customerService ? 'Customer Service' : null
          ].filter(Boolean).join(', ') || 'N/A'}
        </span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Other Engagement:</span>
        <span className="detail-value">{application.otherEngagement || 'N/A'}</span>
      </div>
      
      <h4>Section 5: Value-Added Offerings</h4>
      <div className="detail-row">
        <span className="detail-label">Value-Added Offerings:</span>
        <span className="detail-value">
          {[
            application.productServicePromotions ? 'Product & Service Promotions' : null,
            application.outdoorAdventures ? 'Outdoor Adventures (Excursions & Expeditions)' : null,
            application.industryFacilityToursValue ? 'Industry and Facility Tours' : null,
            application.businessDevelopmentEntrepreneurshipValue ? 'Business Development & Entrepreneurship' : null,
            application.entertainmentLiveEventsValue ? 'Entertainment & Live Events' : null,
            application.communityEngagementCSR ? 'Community Engagement & CSR Initiatives' : null,
            application.sportsRecreationValue ? 'Sports & Recreation' : null,
            application.familyRelationshipsCounselling ? 'Family, Relationships & Counselling' : null,
            application.tourismArtsCultureValue ? 'Tourism, Arts & Culture' : null,
            application.wellnessHealthRelaxation ? 'Wellness, Health & Relaxation' : null,
            application.travelAccommodation ? 'Travel & Accommodation' : null,
            application.wealthFinancialPlanning ? 'Wealth & Financial Planning' : null
          ].filter(Boolean).join(', ') || 'N/A'}
        </span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Other Value Added:</span>
        <span className="detail-value">{application.otherValueAdded || 'N/A'}</span>
      </div>
      
      <h4>Section 6: Entity Profile & Engagement</h4>
      <div className="detail-row">
        <span className="detail-label">Years of Operation:</span>
        <span className="detail-value">{application.yearsOfOperation || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Target Market:</span>
        <span className="detail-value">{application.targetMarket || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Age Demographics:</span>
        <span className="detail-value">{application.ageDemographics?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Effective Marketing Channels:</span>
        <span className="detail-value">{application.effectiveMarketingChannels?.join(', ') || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Collaboration Frequency:</span>
        <span className="detail-value">{application.collaborationFrequency || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Co-host/Sponsor/Mentor:</span>
        <span className="detail-value">{application.coHostSponsorMentor || 'N/A'}</span>
      </div>
      {application.coHostSponsorMentor === 'Yes' && (
        <div className="detail-row">
          <span className="detail-label">Specify How:</span>
          <span className="detail-value">{application.specifyHow?.join(', ') || 'N/A'}</span>
        </div>
      )}
      
      <h4>Section 7: Supplier Empowerment & Business Support</h4>
      <div className="detail-row">
        <span className="detail-label">Supplier Empowerment:</span>
        <span className="detail-value">
          {[
            application.clientCustomerSourcing ? 'Client, customer sourcing' : null,
            application.marketOpportunitiesSupport ? 'Market opportunities and support' : null,
            application.betterPricesDealSuppliers ? 'Better prices deal from suppliers' : null,
            application.accessPreferredVendors ? 'Access to preferred vendors' : null,
            application.strategicSourcingSupport ? 'Strategic sourcing support' : null,
            application.representationSupplierNegotiations ? 'Representation during supplier negotiations' : null,
            application.flexibleSupplierPaymentTerms ? 'Flexible supplier payment terms' : null,
            application.jointSourcingEfforts ? 'Joint sourcing efforts with FMLC partners' : null,
            application.businessDevelopmentServices ? 'Business development services' : null,
            application.enterpriseSupportServices ? 'Enterprise support services provision' : null
          ].filter(Boolean).join(', ') || 'N/A'}
        </span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Other Supplier Empowerment:</span>
        <span className="detail-value">{application.otherSupplierEmpowerment || 'N/A'}</span>
      </div>
      
      <h4>Section 8: Administration Fee & Payment Details</h4>
      <div className="detail-row">
        <span className="detail-label">Agree to Admin Fee:</span>
        <span className="detail-value">{application.agreeAdminFee ? 'Yes' : 'No'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Payment Method:</span>
        <span className="detail-value">{application.paymentMethod || 'N/A'}</span>
      </div>
      {application.paymentMethod === 'Mobile Money Provider (M-Pesa, EcoCash)' && (
        <>
          <div className="detail-row">
            <span className="detail-label">M-Pesa Number:</span>
            <span className="detail-value">{application.mPesaNumber || application.mpesaNumber || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">EcoCash Number:</span>
            <span className="detail-value">{application.ecoCashNumber || application.ecocashNumber || 'N/A'}</span>
          </div>
        </>
      )}
      {application.paymentMethod === 'Bank Deposit/EFT' && (
        <>
          <div className="detail-row">
            <span className="detail-label">Account Holder:</span>
            <span className="detail-value">{application.accountHolder || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Bank Name:</span>
            <span className="detail-value">{application.bankName || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Account Number:</span>
            <span className="detail-value">{application.accountNo || 'N/A'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Branch Code:</span>
            <span className="detail-value">{application.branchCode || 'N/A'}</span>
          </div>
        </>
      )}
      
      <h4>Section 9: Agreement & Signature</h4>
      <div className="detail-row">
        <span className="detail-label">Authorized Signature:</span>
        <span className="detail-value">{application.authorizedSignature || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Date:</span>
        <span className="detail-value">{application.date || 'N/A'}</span>
      </div>
      
      <h4>Attachments</h4>
      <div className="detail-row">
        <span className="detail-label">Personal ID:</span>
        <span className="detail-value">{application.personalIdChecked ? 'Provided' : 'Not Provided'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Business ID:</span>
        <span className="detail-value">{application.businessIdChecked ? 'Provided' : 'Not Provided'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Business Trader's License:</span>
        <span className="detail-value">{application.businessTradersLicenseChecked ? 'Provided' : 'Not Provided'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Tax Clearance Certificate:</span>
        <span className="detail-value">{application.taxClearanceCertificateChecked ? 'Provided' : 'Not Provided'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Business Utility Bill:</span>
        <span className="detail-value">{application.businessUtilityBillChecked ? 'Provided' : 'Not Provided'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Business Sublease Agreement:</span>
        <span className="detail-value">{application.businessSubleaseAgreementChecked ? 'Provided' : 'Not Provided'}</span>
      </div>
      
      <h4>Section 10: Business Partner Application Declaration</h4>
      <h5>1. BUSINESS PARTNER (APPLICANT)</h5>
      <div className="detail-row">
        <span className="detail-label">Title & Full Names:</span>
        <span className="detail-value">{application.applicantTitleFullNames || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Position:</span>
        <span className="detail-value">{application.applicantPosition || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Business Name:</span>
        <span className="detail-value">{application.applicantBusinessName || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Date:</span>
        <span className="detail-value">{application.applicantDate || 'N/A'}</span>
      </div>
      
      <h5>2. FMLC REPRESENTATIVE</h5>
      <div className="detail-row">
        <span className="detail-label">Title & Full Names:</span>
        <span className="detail-value">{application.representativeTitleFullNames || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Position:</span>
        <span className="detail-value">{application.representativePosition || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Date:</span>
        <span className="detail-value">{application.representativeDate || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Signature:</span>
        <span className="detail-value">{application.representativeSignature || 'N/A'}</span>
      </div>
      
      <h5>3. FMLC APPROVER</h5>
      <div className="detail-row">
        <span className="detail-label">Title & Full Names:</span>
        <span className="detail-value">{application.approverTitleFullNames || application.approverName || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Position:</span>
        <span className="detail-value">{application.approverPosition || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Approval Date:</span>
        <span className="detail-value">
          {application.approverDate || application.approvedAt || application.approvalDate || application.approvalTimestamp
            ? new Date((application.approverDate || application.approvedAt || application.approvalDate || application.approvalTimestamp).seconds * 1000).toLocaleDateString()
            : 'N/A'}
        </span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Signature:</span>
        <span className="detail-value">{application.approverSignature || 'N/A'}</span>
      </div>
      
      <h4>Other Comments</h4>
      <div className="detail-row">
        <span className="detail-label">Comments:</span>
        <span className="detail-value">{application.otherComments || 'N/A'}</span>
      </div>
      
      <h4>Submission Metadata</h4>
      <div className="detail-row">
        <span className="detail-label">Submitted By:</span>
        <span className="detail-value">{application.submittedBy || 'N/A'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Last Updated:</span>
        <span className="detail-value">
          {application.lastUpdated
            ? new Date(application.lastUpdated.seconds * 1000).toLocaleDateString()
            : 'N/A'}
        </span>
      </div>
      
      <h4>Status History</h4>
      {application.statusHistory && application.statusHistory.length > 0 ? (
        application.statusHistory.map((status, index) => (
          <div key={index} className="detail-group">
            <div className="detail-row">
              <span className="detail-label">Status {index + 1}:</span>
              <span className="detail-value">{status.status || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Date:</span>
              <span className="detail-value">
                {status.date
                  ? new Date(status.date.seconds * 1000).toLocaleDateString()
                  : 'N/A'}
              </span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Updated By:</span>
              <span className="detail-value">{status.updatedBy || 'N/A'}</span>
            </div>
          </div>
        ))
      ) : (
        <div className="detail-row">
          <span className="detail-label">Status History:</span>
          <span className="detail-value">No history available</span>
        </div>
      )}
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="modal-content large-modal">
        <div className="modal-header">
          <h3>{application.type === 'member' ? 'Member' : 'Partner'} Application Details</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="application-header">
            <div className="detail-row">
              <span className="detail-label">Application ID:</span>
              <span className="detail-value">{application.id || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Status:</span>
              <span className="detail-value">
                <span className={`status-badge status-${application.status || 'pending'}`}>
                  {application.status || 'Pending'}
                </span>
              </span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Submitted Date:</span>
              <span className="detail-value">
                {application.submittedAt || application.createdAt || application.submissionDate || application.dateSubmitted
                  ? new Date((application.submittedAt || application.createdAt || application.submissionDate || application.dateSubmitted).seconds * 1000).toLocaleDateString()
                  : 'N/A'}
              </span>
            </div>
          </div>
          
          {application.type === 'member' ? renderMemberDetails() : renderPartnerDetails()}
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationModal;